import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';
const API_BASE_URL = '/api/netsuite';

export const cancelPunchoutSession = async (sessionId: string): Promise<void> => {
  try {
    await axios.delete(`${API_BASE_URL}/session/${encodeURIComponent(sessionId)}`);
  } catch (error) {
    console.error('Error cancelling PunchOut session:', error);
  }
};

export const reportSessionTiming = async (
  sessionId: string,
  startTime: string,
  endTime: string
): Promise<void> => {
  try {
    await axios.post(`${API_BASE_URL}/session-timing`, { sessionId, startTime, endTime });
  } catch (error) {
    console.error('Error reporting PunchOut session timing:', error);
  }
};

export const postToNetSuite = async (sessionId:string): Promise<string> => {
  try {

   const response = await axios.post<string>(`${API_BASE_URL}/oauth`, {sessionId}, {
    headers: { "Content-Type": "application/json" },
    responseType: "text"
    });
    const parser = new XMLParser({
        ignoreAttributes: false,  // keeps XML attributes
        trimValues: true,         // trims whitespace
        });
    const parsed = parser.parse(response.data);
    console.log(parsed);
    const start_url = parsed?.cXML?.Response?.PunchOutSetupResponse?.StartPage?.URL;
    console.log(start_url)
  return start_url;
  } catch (error) {
    console.error('Error posting to NetSuite:', error);
    throw new Error('Failed to get start URL');
  }
};

